import { Component, OnInit } from '@angular/core';
import { SessionService } from 'src/app/shared/session-service/session.service';
import { environment } from 'src/environments/environment';
import { UserDataService } from '../../services/user-data.service';
import { UserDetails } from '../../models/user-details.model';
import { role } from 'src/app/shared/constants/role-enum';

@Component({
  selector: 'admin-menu',
  templateUrl: 'admin-menu.component.html',
  styleUrls: ['./admin-menu.component.scss'],
})
export class AdminMenuComponent implements OnInit {
  engagementId: string;
  rcsWatsonStudyId: string;
  rcsContractAnalysisStudyId: string;
  rcsUrl: string;
  rcsContractUrl: string;
  userData: UserDetails;
  isChampionUser = false;

  constructor(public sessionService: SessionService, private userDataService: UserDataService) { }

  ngOnInit() {
    this.userDataService.userDetails$.subscribe(data => {
      if (data && data.userId > 0) {
        this.userData = data;
        this.isChampionUser = this.userData.roleId === role.champion ? true : false;
      }
    })
  }

  onGoToRcsWatson() {
    this.rcsWatsonStudyId = this.sessionService.getSession('rcsWatsonStudyId');
    if (this.rcsWatsonStudyId) {
      this.rcsUrl = environment.rcsWatsonDeepLink.replace(
        '?',
        this.rcsWatsonStudyId + '?',
      );
    } else {
      this.rcsUrl = environment.rcsWatsonDeepLink;
    }

    window.open(this.rcsUrl, '_blank');
  }

  onGoToRcsContract() {
    this.rcsContractAnalysisStudyId = this.sessionService.getSession('rcsContractAnalysisStudyId');

    if (this.rcsContractAnalysisStudyId) {
      this.rcsContractUrl = environment.rcsContractDeepLink.replace(
        '?',
        this.rcsContractAnalysisStudyId + '?',
      );
    } else {
      this.rcsContractUrl = environment.rcsContractDeepLink;
    }


    window.open(this.rcsContractUrl, '_blank');
  }
}
